import { render, staticRenderFns } from "./AnswerQuestions.vue?vue&type=template&id=31ec21ac&scoped=true&lang=html&"
import script from "./AnswerQuestions.vue?vue&type=script&lang=js&"
export * from "./AnswerQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AnswerQuestions.vue?vue&type=style&index=0&id=31ec21ac&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ec21ac",
  null
  
)

export default component.exports